import { DuvidaResolvida, Response, SituacaoInterconsulta } from '../../../../../_metronic/helpers'
import { IOption } from '../../../../components'

/** `ceae` = só unidades CEAE (ceae=true); `nao-ceae` = só as demais (ceae=false); sem filtro = todas. */
export type FiltroCeae = 'ceae' | 'nao-ceae'

export type AgrupamentoQuantitativo = 'especialidade' | 'solicitante'

/**
 * Estado dos filtros da página (contexto de `createListFilters`): empresa como opção do select,
 * datas AAAA-MM-DD, competência AAAA-MM. `agrupar` só vale para a aba Quantitativo.
 */
export type FiltroRelatorios = {
  empresa?: IOption<number>
  dataInicio: string
  dataFim: string
  ceae?: IOption<FiltroCeae>
  competencia: string
  agrupar: AgrupamentoQuantitativo
}

/** Parâmetros comuns às rotas de período (`dataInicio`/`dataFim` inclusivos, máx. 366 dias). */
export type ParametrosPeriodo = {
  empresa: number
  dataInicio: string
  dataFim: string
  ceae?: boolean
}

export type ParametrosAnexoIi = {
  empresa: number
  competencia: string
  ceae?: boolean
}

export type FormatoRelatorio = 'json' | 'csv' | 'xlsx'

export type ArquivoRelatorio = {
  blob: Blob
  nomeArquivo: string
}

/** Situação na nomenclatura do Anexo II (derivada da situação da interconsulta). */
export enum SituacaoAnexoIi {
  Respondida = 'RESPONDIDA',
  Cancelada = 'CANCELADA',
  Devolvida = 'DEVOLVIDA',
  EmAndamento = 'EM_ANDAMENTO',
}

export type RatcProfissional = {
  nome?: string
  cns?: string
  cbo?: string
  cnes?: string
  estabelecimento?: string
  ine?: string
  codigoIbge?: string
}

export type RatcReplica = {
  data?: string
  autor?: string
  texto?: string
}

export type RatcTeleconsultoria = {
  identificador?: string
  codigoNucleo?: string
  especialidade?: string
  abertura?: string
  primeiraResposta?: string
  conclusao?: string
  encerramento?: string
  situacao?: SituacaoInterconsulta
  situacaoAnexoIi?: SituacaoAnexoIi
  horasResposta?: number
  cids?: string[]
  ciaps?: string[]
  ceae?: boolean
  /** Só no registro individual (GET /atendimentos/interconsulta/{id}/ratc). */
  motivo?: string
  replicas?: RatcReplica[]
}

export type RatcDesfecho = {
  duvidaResolvida?: DuvidaResolvida
  intencaoEncaminhar?: boolean
  encaminhamentoEvitado?: boolean
  satisfacao?: number
  acaoAdotada?: string
  data?: string
}

/** Registro do RATC (dicionário em docs/ratc-dicionario.md, no backend). */
export type RatcRegistro = {
  id: number
  paciente?: { cpf?: string; cns?: string }
  solicitante?: RatcProfissional
  teleconsultor?: RatcProfissional
  teleconsultoria?: RatcTeleconsultoria
  desfecho?: RatcDesfecho
}

export type RatcQueryResponse = Response<Array<RatcRegistro>>

/** Relatório mensal do Anexo II em JSON: as 17 colunas fixas + contadores de qualidade do dado. */
export type RelatorioAnexoIi = {
  empresaId: number
  codigoSes?: string
  competencia: string
  ceae?: boolean
  cabecalho: string[]
  linhas: string[][]
  totalLinhas: number
  semLotacaoSolicitante: number
  semCbo: number
  semCid: number
}

export type LinhaQuantitativo = {
  chave: string
  total: number
  respondidas: number
  canceladas: number
  tempoRespostaMediaHoras?: number | null
  satisfacaoMedia?: number | null
  satisfacaoN: number
}

export type QuantitativoInterconsulta = {
  empresaId: number
  dataInicio: string
  dataFim: string
  agrupamento: string
  ceae?: boolean
  total: number
  linhas: LinhaQuantitativo[]
}

export type IndicadoresInterconsulta = {
  empresaId: number
  dataInicio: string
  dataFim: string
  ceae?: boolean
  total: number
  respondidas: number
  canceladas: number
  semLotacaoSolicitante: number
  tempoResposta: {
    ate72h: number
    de72a144h: number
    acima144h: number
    mediaHoras?: number | null
    medianaHoras?: number | null
    n: number
  }
  satisfacao: {
    media?: number | null
    n: number
    /** Chaves "1".."5" (Map<Integer, Long> serializado). */
    distribuicao: Record<string, number>
    metaAtingida?: boolean | null
  }
}

export type AbaRelatorio = 'indicadores' | 'quantitativo' | 'ratc' | 'mensal'
